/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { Router } from "@angular/router";

import { AuthenticationService } from './authentication.service';
import { BaseService } from "./base-service";

import { Workflow } from '../models/workflow';
import { RestService } from './rest-service';
import { Url_Base } from 'app/rest-constants';

@Injectable()
export class WorkflowService extends BaseService{

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private mRestService: RestService
    ) { super(router, authenticationService); }
    
    private getUrl(): string {
       return `${Url_Base}/workflow/`;
    }
    
    getAllWorkflows(): Promise<Workflow[]> {
        const url = this.getUrl();
        
        return this.mRestService.get<Workflow[]>(url);
    }
    
    getAllWorkflowById(id: number): Promise<Workflow> {
        const url = this.getUrl() + `${id}`;
        
        return this.mRestService.get<Workflow>(url);
    }
    
    createWorkflow(workflow: Workflow): Promise<Workflow> {
        const url = this.getUrl();
        
        return this.mRestService.post<Workflow>(url, workflow);
    }

}
